'use client';
import React from 'react';

import { useTranslations } from 'next-intl';
import styled from 'styled-components';

import SearchResultItem from './SearchResultItem';
import SearchResultsWrapper from './SearchResultsWrapper';
import { filterSearchResults } from '../actions/filterSearchResults';
import { useSearchResultsContext } from '../context/SearchResultsContext';

const NoResults = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  font-size: 2rem;
  color: #808080;
  font-weight: bold;
  line-height: normal;
`;

interface SearchResultListProps {
  searchExpression: string;
  products: Product[];
}

export default function SearchResultList({
  // locale,
  products,
  searchExpression,
}: SearchResultListProps) {
  const translate = useTranslations();
  const { activeFilters, searchResults } = useSearchResultsContext();

  const filteredSearchResults = React.useMemo(
    () =>
      filterSearchResults({
        searchResults,
        activeFilters,
        products,
      }),
    [searchExpression, searchResults?.length, JSON.stringify(activeFilters)]
  );

  if (!filteredSearchResults.length) {
    return <NoResults>{translate('searchPage-noResults')}</NoResults>;
  }

  return (
    <SearchResultsWrapper>
      {filteredSearchResults.map(searchResult => (
        <SearchResultItem
          searchExpression={searchExpression}
          key={searchResult.id}
          title={searchResult.document?.derivedStructData?.title}
          href={searchResult.document?.derivedStructData?.link}
          description={
            searchResult.document?.derivedStructData?.extractive_answers?.[0]
              ?.content
          }
          noBorder
        />
      ))}
    </SearchResultsWrapper>
  );
}
